import React from 'react'
import { InflatedProductBomWithRoom } from '../bom/bomUtils'

import { RawBomScreen } from '../BomScreen'

import './ListScreen.scss'
import { Room } from './ListTypes'

interface Props {
  products: readonly InflatedProductBomWithRoom[]
  rooms: readonly Room[]
  onClickDownloadList: () => void
  scrollable: boolean
}

const SharedBomScreen: React.FunctionComponent<Props> = ({ products, rooms, onClickDownloadList, scrollable }) => {
  return (
    <div
      className="ListScreen"
      style={!scrollable ? {
        height: 'unset',
        overflowY: 'unset',
      } : undefined}
      onClick={e => {
        e.stopPropagation()
      }}
    >
      <div>
        <RawBomScreen
          products={products}
          rooms={rooms}
          onClickDownloadList={onClickDownloadList}
        />
      </div>
    </div>
  )
}

export default SharedBomScreen
